module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor19-5a9a15bc18adddef661fa09779e66421.png";